import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {twoColumnsDefaultContent} from './twoColumnsSectionDefaultContent';
import {componentsHelper} from "../../helpers/componentsHelper";
import l10n from "../../../lang/locallang";

const twoColumnsSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(twoColumnsDefaultContent);
    const { twoColumnsText } = l10n;
    const defaultValue = `
        <div class="row">
            <div class="col-50p">
                <div class="fr-editor-paragraph" id="input_text_section_1">
                    <p>${twoColumnsText.p1}</p>
                    <p>${twoColumnsText.p2}</p>
                </div>
            </div>
            <div class="col-50p">
                <div class="fr-editor-paragraph" id="input_text_section_2">
                    <ul>
                        <li>${twoColumnsText.li1}</li>
                        <li>${twoColumnsText.li2}</li>
                        <li>${twoColumnsText.li3}</li>
                        <li>${twoColumnsText.li4}</li>
                    </ul>
                </div>
            </div>
        </div>
    `;
    param.class = param.class ? param.class : 'editor-section';
    let content = param.content && param.content.text ? param.content.text : defaultValue;
    param.style = param.style ? param.style : '';
    param.section = 'twoColumnsSection';
    param.component = `
        <div class="editor-section_container fr-editor-container two-columns-text">
            ${content}
        </div>`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {twoColumnsSection};
